/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CampaignInitialProperties,
  CampaignProperties,
} from '../../interface/campaign-management.interface';
import ConvertUTCtoDate from '../../shared-functions/ConvertUTCtoDate';
import campaignApi from '../../utils/api/campaign';

// a thunk to fetch users
export const fetchCampaignsApi = createAsyncThunk(
  'campaign/fetchCampaign',
  async (_, { dispatch }) => {
    try {
      const response = await campaignApi.fetchCampaigns();
      const responseTemporary = {
        results: response.data.map((data: any) => {
          return {
            ...data,
            date: ConvertUTCtoDate(data.createdAt),
            totalAccounts: data.accountCustomIds.length,
            id: data.campaignId,
          };
        }),
      };

      return responseTemporary;
    } catch (error: any) {
      dispatch({
        type: 'notification/setNotificationDetails',
        payload: {
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        },
      });
      throw error;
    }
  },
);

export const fetchSingleCampaignsApi = createAsyncThunk(
  'campaign/fetchSingleCampaign',
  async (campaignId: keyof CampaignProperties, { dispatch }) => {
    try {
      const response = await campaignApi.fetchSingleCampaign(campaignId);
      return response.data;
    } catch (error: any) {
      dispatch({
        type: 'notification/setNotificationDetails',
        payload: {
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        },
      });
      throw error;
    }
  },
);

// Initial state
const initialState: CampaignInitialProperties = {
  results: [],
  loading: false,
};

// Create the slice
export const fetchCampaignSlice = createSlice({
  name: 'campaign-fetch',
  initialState,
  reducers: {},
  /**
   * Use the extra reducers function
   * @param builder
   */
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCampaignsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload.results;
      })
      .addCase(fetchCampaignsApi.rejected, (state) => {
        state.loading = false;
      });
  },
});
// Export the reducer
export default fetchCampaignSlice.reducer;
